import { createGlobalStyle } from 'styled-components';

/* The HSOC v2 pricing pages use a white page background instead of the grey
 * (fill-surface-recessed) body background applied app-wide by
 * BodyBackgroundStyles. Rendering this override only from the HSOC v2 pages
 * keeps every other pricing page on the shared grey background — the override
 * is removed automatically when the page unmounts. */
export const HsocBodyBackgroundStyles = createGlobalStyle(({
  theme
}) => ({
  'html body': {
    backgroundColor: theme.color['fill-surface-default']
  }
}));